import { render } from "./InstructorDetailsPage.vue?vue&type=template&id=32e6d3b4&ts=true"
import script from "./InstructorDetailsPage.vue?vue&type=script&lang=ts"
export * from "./InstructorDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__